// extracted by mini-css-extract-plugin
export default {"heading":"Products_heading__f08TV","name":"Products_name__JDtxP","subcontent":"Products_subcontent__rblU+"};